import { render, staticRenderFns } from "./BackgroundThemeColor.vue?vue&type=template&id=9e76520e&scoped=true"
import script from "./BackgroundThemeColor.vue?vue&type=script&lang=js"
export * from "./BackgroundThemeColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e76520e",
  null
  
)

export default component.exports